import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-chat-message-text',
  templateUrl: './chat-message-text.component.html',
  styleUrls: ['./chat-message-text.component.scss']
})
export class ChatMessageTextComponent implements OnInit {

  @Input() index: number;
  @Input() elements: any;

  constructor() { }

  ngOnInit() { }

}
